// Modal para abrir imagens
class ImageModal {
  constructor() {
    this.modal = null;
    this.modalImage = null;
    this.init();
  }

  init() {
    // Criar modal HTML
    const modalHTML = `
      <div id="imageModal" class="hidden fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
        <div class="relative max-w-4xl max-h-[90vh]">
          <img id="modalImage" src="" alt="Imagem ampliada" class="max-w-full max-h-[85vh] object-contain rounded-lg">
          <button id="closeModal" class="absolute top-4 right-4 bg-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-200 transition">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    this.modal = document.getElementById('imageModal');
    this.modalImage = document.getElementById('modalImage');
    const closeBtn = document.getElementById('closeModal');

    // Event listeners
    document.querySelectorAll('.gallery-image').forEach(img => {
      img.addEventListener('click', () => this.openModal(img.src));
    });

    closeBtn.addEventListener('click', () => this.closeModal());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeModal();
    });
  }

  openModal(imageSrc) {
    this.modalImage.src = imageSrc;
    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.add('hidden');
    document.body.style.overflow = 'auto';
  }
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  new ImageModal();

  // Smooth scroll para links internos
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});
